export default "/assets/images/graph-smoke-sm.b2a003859fd9f6df.png";